import { Skeleton } from 'antd';
import { useState } from 'react';

import { Avatar, AvatarProps } from 'components/data-display/Avatar';

import { useUsersData } from 'hooks/useUsersData';

import { cn } from 'utils/cn';
import { getAvatarConfig } from 'utils/users/config';

const avatarSizeToSkeletonSize = (size: UserAvatarProps['size']) => {
  if (typeof size === 'number') return size;
  if (typeof size === 'string') {
    if (['small', 'default', 'large'].includes(size)) return size;
  }
  return 'default';
};

export interface UserAvatarProps extends AvatarProps {
  userId: string;
  /**
   * @deprecated the user data is loaded from useUsersData and loading state is handled.
   * Only use this prop if you need to override the loading state.
   */
  isLoading?: boolean;
}

const UserAvatar = ({
  userId,
  isLoading = false,
  size = 'small',
  ...props
}: UserAvatarProps) => {
  const { usersMap, isLoading: isLoadingUsers } = useUsersData();
  const [erroredUrl, setErroredUrl] = useState<string | undefined>(undefined);

  if (isLoading || isLoadingUsers)
    return <Skeleton.Avatar active size={avatarSizeToSkeletonSize(size)} />;

  const { initials, color, bgColor, imageSrc, logoSrc, className } =
    getAvatarConfig(userId, usersMap);

  const src = imageSrc && imageSrc !== erroredUrl ? imageSrc : undefined;

  return (
    <Avatar
      size={size}
      src={logoSrc || src}
      backgroundColor={logoSrc || !src ? bgColor : undefined}
      color={logoSrc || !src ? color : undefined}
      onError={() => {
        setErroredUrl(imageSrc);
        return true;
      }}
      {...props}
      className={cn('shrink-0', props.className, className)}
    >
      {!src && !logoSrc ? initials : null}
    </Avatar>
  );
};

export { UserAvatar };
